module.exports = __webpack_public_path__ + "static/media/attendee.46c6c85c.png";